import { memo, useState } from "react";
import { OrganizationIntegrationAccountItem } from "@common/schemas/organization-connection-groups.schema";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { EditableCellContent } from "@design-system/ViewTable/EditableCellContent";
import { NO_REASSIGNMENT_TOOLTIP } from "../assignmentCopy";
import { ClientAssignmentModal } from "../ClientAssignmentModal";
import { useOrganizationIntegrations } from "../OrganizationIntegrationsContext";
import styles from "../IntegrationsPage.module.scss";

export const ClientCell = memo(
    ({ item }: { item: OrganizationIntegrationAccountItem }) => {
        const { account } = item;
        const { workspaces, pendingByAccountId } =
            useOrganizationIntegrations();
        const [isAssigning, setIsAssigning] = useState(false);

        if (account.entityId !== null) {
            return (
                <Tooltip content={NO_REASSIGNMENT_TOOLTIP}>
                    <span className={styles.lockedClient}>
                        {account.entity?.workspaceName ?? "-"}
                    </span>
                </Tooltip>
            );
        }

        const stagedWorkspaceId =
            pendingByAccountId[account.id]?.workspaceId ?? null;
        const stagedWorkspaceName = workspaces.find(
            (workspace) => workspace.id === stagedWorkspaceId,
        )?.name;

        return (
            <>
                {/* Reads as plain text until the row is hovered, so an
                    unassigned table isn't a wall of boxes. */}
                <EditableCellContent
                    className={styles.assignmentCellValue}
                    onClick={() => setIsAssigning(true)}
                >
                    {stagedWorkspaceId === null
                        ? "Select client"
                        : (stagedWorkspaceName ?? "Untitled client")}
                </EditableCellContent>
                {isAssigning && (
                    <ClientAssignmentModal
                        accountIds={[account.id]}
                        initialWorkspaceId={stagedWorkspaceId}
                        onClose={() => setIsAssigning(false)}
                    />
                )}
            </>
        );
    },
);

ClientCell.displayName = "ClientCell";
